import { api } from '@/api'

export interface PaymentSetting {
  id: string
  name: string
  isActive: boolean
  isDefault: boolean
  redirectUrl?: string
  verifyUrl?: string
  paymentUrl?: string
  createdAt: string
  updatedAt: string
}

export const getPaymentSettingsAction = () => api.v2.get<{ data: PaymentSetting[] }>('/payment-settings')

export const getPaymentSettingAction = (id: string) => api.v2.get<{ data: PaymentSetting }>(`/payment-settings/${id}`)

export const updatePaymentSettingAction = (id: string, payload: Record<string, unknown>) =>
  api.v2.put<{ data: PaymentSetting }>(`/payment-settings/${id}`, payload)

export const setDefaultPaymentSettingAction = (id: string) =>
  api.v2.patch<{ data: PaymentSetting }>(`/payment-settings/${id}`)

export const deletePaymentSettingAction = (id: string) => api.v2.delete(`/payment-settings/${id}`)
